__turbopack_context__.v({
  "className": "roboto_59cf392f-module__-61AbW__className",
  "variable": "roboto_59cf392f-module__-61AbW__variable",
});
